import { render, staticRenderFns } from "./couponExpand.vue?vue&type=template&id=435a0ec9&scoped=true"
import script from "./couponExpand.vue?vue&type=script&lang=js"
export * from "./couponExpand.vue?vue&type=script&lang=js"
import style0 from "./couponExpand.vue?vue&type=style&index=0&id=435a0ec9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a0ec9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('435a0ec9')) {
      api.createRecord('435a0ec9', component.options)
    } else {
      api.reload('435a0ec9', component.options)
    }
    module.hot.accept("./couponExpand.vue?vue&type=template&id=435a0ec9&scoped=true", function () {
      api.rerender('435a0ec9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/couponExpand/couponExpand.vue"
export default component.exports